import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Envuelve páginas que preferimos deshabilitar en móvil.
// Si el viewport es <= 768px, muestra un mensaje y atajos a Ventas/Productos.
const MobileGuard = ({ children }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  // Permite forzar la vista de escritorio en este dispositivo
  const [bypassPersisted, setBypassPersisted] = useState(() => {
    try {
      return localStorage.getItem('mobileGuardBypass') === '1';
    } catch {
      return false;
    }
  });
  // Ignorar sólo por esta sesión/visita
  const [bypassOnce, setBypassOnce] = useState(false);

  useEffect(() => {
    // Umbral más conservador para evitar falsos positivos en escritorio con ventanas medianas/zoom
    const mq = window.matchMedia('(max-width: 640px)');
    const update = () => setIsMobile(mq.matches);
    update();
    if (mq.addEventListener) mq.addEventListener('change', update);
    else mq.addListener(update);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', update);
      else mq.removeListener(update);
    };
  }, []);

  useEffect(() => {
    try {
      if (bypassPersisted) localStorage.setItem('mobileGuardBypass', '1');
      else localStorage.removeItem('mobileGuardBypass');
    } catch {
      // ignorar
    }
  }, [bypassPersisted]);

  // Si está forzado el modo escritorio, ignorar guard
  const forceDesktop = (() => {
    try { return localStorage.getItem('forceDesktop') === '1'; } catch { return false; }
  })();

  // Si no es móvil o hay bypass, mostramos el contenido
  if (!isMobile || bypassPersisted || bypassOnce || forceDesktop) return children;

  return (
    <div className="container-safe" style={{ padding: '24px' }}>
      <div style={{
        maxWidth: 560,
        margin: '40px auto',
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 6px 24px rgba(0,0,0,0.08)',
        padding: 24,
        textAlign: 'center'
      }}>
        <div style={{ fontSize: 28, marginBottom: 8 }}>📱 Vista no disponible en móvil</div>
        <p style={{ color: '#444', marginBottom: 18 }}>
          Esta sección se ve mejor en pantallas grandes. En el celular podés usar los flujos principales:
        </p>
        <div className="stack-sm" style={{ justifyContent: 'center' }}>
          <button
            onClick={() => navigate('/sales')}
            style={{ background: '#28a745', color: '#fff', border: 'none', padding: '12px 16px', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}
          >
            💵 Ir a Ventas
          </button>
          <button
            onClick={() => navigate('/products')}
            style={{ background: '#007bff', color: '#fff', border: 'none', padding: '12px 16px', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}
          >
            📦 Ir a Productos
          </button>
        </div>
        <div style={{ marginTop: 16, display: 'grid', gap: 8 }}>
          <button
            onClick={() => setBypassOnce(true)}
            style={{ background: '#6c757d', color: '#fff', border: 'none', padding: '10px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}
          >
            ➜ Abrir de todas formas (esta vez)
          </button>
          <button
            onClick={() => setBypassPersisted(true)}
            style={{ background: '#343a40', color: '#fff', border: 'none', padding: '10px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}
          >
            ✅ No volver a mostrar en este dispositivo
          </button>
          <small style={{ color: '#666' }}>
            Consejo: si fue un error, ampliá la ventana o reducí el zoom del navegador; también podés deshacer esta preferencia en Empresa › Identidad visual.
          </small>
        </div>
      </div>
    </div>
  );
};

export default MobileGuard;
